var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCLogoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n        stroke-width: 16px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M705.9,234.9v78.2c0,5.4-4.4,9.8-9.8,9.8h-412c-5.4,0-9.8-4.4-9.8-9.8h0c0-48.6,39.4-88,88-88h333.7c5.4,0,9.8,4.4,9.8,9.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.4,323h4.3c6.7,0,12.1,5.4,12.1,12.1v320.4c0,6.7-5.4,12.1-12.1,12.1h-4.3c-54,0-97.8-43.8-97.8-97.8v-149.1c0-54,43.8-97.8,97.8-97.8h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 706,
    y: 542.2,
    width: 134.4,
    height: 125.4,
    rx: 12.3,
    ry: 12.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M705.8,755.3c0,5.4-4.4,9.8-9.8,9.8h-333.7c-48.6,0-88-39.4-88-88h0c0-5.4,4.4-9.8,9.8-9.8h412c5.4,0,9.8,4.4,9.8,9.8v78.2h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCLogoOutline);
export default __webpack_public_path__ + "static/media/CLogo-Outline.a7056ff18b4b03b4b525837be581d8f6.svg";
export { ForwardRef as ReactComponent };